export default __webpack_public_path__ + "static/view_02-25_2-6f1d215666ef2951f4e4f6bb9f2b87a7.jpg";